<template>
  <div class="pst-node-wrap">
    <div class="pst-node-card" :class="depth === 0 ? 'pst-node-card--root' : 'pst-node-card--child'">
      <div class="pst-node-icon" :class="depth === 0 ? 'pst-node-icon--root' : 'pst-node-icon--child'">
        <i :class="depth === 0 ? 'bx bx-crown' : 'bx bx-user-pin'"></i>
      </div>
      <div class="pst-node-body">
        <div class="pst-node-title-row">
          <strong>{{ node.positionName }}</strong>
          <span v-if="node.code" class="hr-badge hr-badge-secondary">{{ node.code }}</span>
        </div>
        <p v-if="node.description" class="pst-node-desc">{{ node.description }}</p>
        <div class="pst-node-meta">
          <span v-if="roleCount" class="pst-meta-chip">
            <i class="bx bx-shield-quarter"></i> {{ roleCount }} role{{ roleCount === 1 ? '' : 's' }}
          </span>
          <span v-if="childCount" class="pst-meta-chip pst-meta-chip--muted">
            <i class="bx bx-git-branch"></i> {{ childCount }} direct report{{ childCount === 1 ? '' : 's' }}
          </span>
        </div>
        <div v-if="node.roleNames && node.roleNames.length" class="pst-role-badges">
          <span v-for="r in node.roleNames.slice(0, 4)" :key="r" class="hr-badge hr-badge-primary">{{ r }}</span>
          <span v-if="node.roleNames.length > 4" class="hr-badge hr-badge-muted">+{{ node.roleNames.length - 4 }}</span>
        </div>
      </div>
    </div>
    <div v-if="children.length" class="pst-children">
      <PositionTreeNode
        v-for="child in children"
        :key="child.id"
        :node="child"
        :positions="positions"
        :depth="depth + 1"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "PositionTreeNode",
  props: {
    node: { type: Object, required: true },
    positions: { type: Array, default: () => [] },
    depth: { type: Number, default: 0 }
  },
  computed: {
    children() {
      return this.positions
        .filter((p) => p.parentPositionId === this.node.id)
        .sort((a, b) => (a.positionName || "").localeCompare(b.positionName || ""));
    },
    childCount() {
      return this.children.length;
    },
    roleCount() {
      return (this.node.roleNames || []).length;
    }
  }
};
</script>

<style scoped>
.pst-node-wrap {
  position: relative;
}

.pst-node-card {
  display: flex;
  gap: 14px;
  padding: 14px 16px;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
  transition: box-shadow 0.2s, transform 0.2s;
  margin-bottom: 10px;
}

.pst-node-card:hover {
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.pst-node-card--root {
  background: linear-gradient(135deg, #eef2ff 0%, #f8fafc 100%);
  border-color: #c7d2fe;
  border-left: 4px solid #6366f1;
}

.pst-node-card--child {
  border-left: 3px solid #94a3b8;
}

.pst-node-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  flex-shrink: 0;
}

.pst-node-icon--root {
  background: #fff;
  color: #4f46e5;
  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.15);
}

.pst-node-icon--child {
  background: #f1f5f9;
  color: #64748b;
}

.pst-node-body {
  flex: 1;
  min-width: 0;
}

.pst-node-title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 4px;
}

.pst-node-title-row strong {
  font-size: 1rem;
  color: #0f172a;
}

.pst-node-desc {
  margin: 0 0 8px;
  font-size: 0.85rem;
  color: #64748b;
  line-height: 1.4;
}

.pst-node-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.pst-meta-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #475569;
}

.pst-meta-chip--muted {
  color: #94a3b8;
}

.pst-role-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.pst-children {
  margin-left: 22px;
  padding-left: 18px;
  border-left: 2px dashed #cbd5e1;
}
</style>
